export default {
  name: 'TablePagination',
  props: {
    page: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizeOptions: {
      type: Array,
      default: () => [10, 25, 50, 100]
    },
    totalRows: {
      type: Number,
      default: 0
    },
    pageStart: {
      type: Number,
      default: 0
    },
    pageEnd: {
      type: Number,
      default: 0
    },
    totalPages: {
      type: Number,
      default: 1
    }
  },
  emits: ['update:page', 'update:pageSize']
};
